import ready from './ready';
import headMenu from './headMenu';

ready(() => {
  headMenu();
});
